import FieldEntry from 'pages/requestList/components/FieldEntry';
import { memo } from 'react';

import { messages } from './QBooksJournalEntryMemoSection.messages';
import { StyledSectionContainer } from './QBooksJournalEntryMemoSection.styles';
import { QBooksJournalEntryMemoSectionProps } from './QBooksJournalEntryMemoSection.types';

const QBooksJournalEntryMemoSection = memo<QBooksJournalEntryMemoSectionProps>((props) => {
    const { memo } = props;

    if (!memo) {
        return null;
    }

    return (
        <StyledSectionContainer title={messages.fieldTitle}>
            <FieldEntry title={null} value={memo} />
        </StyledSectionContainer>
    );
});

export default QBooksJournalEntryMemoSection;
